<script>
import SignaturePad from "./SignaturePad.vue"
import Swal from "sweetalert2"

export default {
  name: "DocumentActions",
  components: { SignaturePad },
  props: {
    documentId: { type: [Number, String], required: true },
    companyId: { type: [Number, String], required: true },
    workflowStatus: { type: String, default: "draft" },
    signedAt: { type: String, default: null },
    documentTitle: { type: String, default: "Documento" },
    apiService: { type: Object, required: true },
    signerRole: { type: String, default: "gerente" },
  },
  data() {
    return {
      showSignModal: false,
      signing: false,
      localStatus: this.workflowStatus,
      localSignedAt: this.signedAt,
    }
  },
  watch: {
    workflowStatus(v) { this.localStatus = v },
    signedAt(v) { this.localSignedAt = v },
  },
  computed: {
    isDraft() { return this.localStatus === "draft" },
    isSigned() { return this.localStatus === "signed" },
    badgeClass() {
      return this.isSigned ? "badge-signed" : "badge-draft"
    },
    badgeText() {
      return this.isSigned ? "VIGENTE — Firmado" : "BORRADOR"
    },
    signedDate() {
      if (!this.localSignedAt) return null
      const d = new Date(this.localSignedAt)
      return d.toLocaleString("es-CO", {
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit",
      })
    },
  },
  methods: {
    downloadPdf() {
      window.open(this.apiService.pdfUrl(this.documentId), "_blank")
    },
    openSign() {
      this.showSignModal = true
    },
    async onSign({ signature_id }) {
      this.signing = true
      try {
        const res = await this.apiService.sign(this.documentId, {
          signature_id,
          consent: true,
        })
        if (res && res.workflow_status === "signed") {
          this.localStatus = "signed"
          this.localSignedAt = res.signed_at
          this.showSignModal = false
          this.$emit("signed", res)
          Swal.fire({
            icon: "success",
            title: "Documento firmado",
            text: "El PDF firmado queda registrado de forma inmutable.",
            timer: 2500,
            showConfirmButton: false,
          })
        } else {
          Swal.fire("Error", (res && res.message) || "No se pudo firmar", "error")
        }
      } catch (e) {
        Swal.fire("Error", "Ocurrió un problema al firmar", "error")
      } finally {
        this.signing = false
      }
    },
  },
}
</script>

<template>
  <div class="doc-actions card">
    <div class="card-body">
      <div class="da-state">
        <span class="da-badge" :class="badgeClass">{{ badgeText }}</span>
        <div v-if="isSigned && signedDate" class="da-signed-date">
          {{ signedDate }}
        </div>
      </div>

      <hr />

      <div class="da-buttons">
        <button class="btn btn-light btn-block btn-sm mb-2" @click="downloadPdf">
          📥 Descargar PDF
          <span v-if="isDraft" class="text-muted small"> (borrador)</span>
        </button>

        <button
          v-if="isDraft"
          class="btn btn-primary btn-block btn-sm"
          @click="openSign"
        >
          🖊️ Firmar y emitir
        </button>

        <div v-else class="text-muted small text-center">
          Documento bloqueado para edición
        </div>
      </div>
    </div>

    <SignaturePad
      :visible="showSignModal"
      :company-id="companyId"
      :document-title="documentTitle"
      :role-filter="signerRole"
      @close="showSignModal = false"
      @sign="onSign"
    />
  </div>
</template>

<style scoped>
.doc-actions { position: sticky; top: 80px; }
.da-state { text-align: center; }
.da-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.badge-draft { background: #f4f4f4; color: #666; border: 1px solid #ddd; }
.badge-signed { background: #d4edda; color: #155724; border: 1px solid #c3e6cb; }
.da-signed-date { font-size: 0.75rem; color: #666; margin-top: 6px; }
.da-buttons { display: flex; flex-direction: column; }
</style>
